import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { HOME_PRODUCT_SECTION_IDS } from "../../../../common/constant";
import { IRootState } from "../../../../models/interface";
import { sections } from "../../../../services";
import _ from "lodash";

const initialState: any = {
  sections: [],
  offset: 0,
};

export const commonSlice = createSlice({
  name: "home",
  initialState: initialState,
  reducers: {
    setSections: (state, action) => {
      state.sections = state.sections.concat(action.payload.data);
      state.offset = action.payload.offset;
    },

    isLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setSections, isLoading } = commonSlice.actions;

export const getSections =
  (offset: number, limit: number) => (dispatch: Dispatch) => {
    sections.getSections(
      {
        ids: HOME_PRODUCT_SECTION_IDS.slice(offset, limit),
      },
      (data: any, err: any) => {
        if (data && data.data.length) {
          dispatch(
            setSections({
              data: _.sortBy(data.data, ["order"]),
              offset: offset + limit,
            })
          );
        }
      }
    );
  };

export const selectSections = (state: IRootState) => state.home.sections;
export const selectOffset = (state: IRootState) => state.home.offset;
export const selectIsLoading = (state: IRootState) => state.common.loading;

export default commonSlice.reducer;
